import { useRouter } from 'next/router'

import s from './ProgressBar.module.css'

export const getStepNumber = (path: string): number => {
  return parseInt(path.split('/')[2].split('-')[0], 10)
}

const ProgressBar: React.FC = () => {
  const router = useRouter()

  const step = getStepNumber(router.pathname)

  const progressCheckmark = (
    <img width="10" height="9" src="/assets/o_series/progress_check.svg" />
  )

  const progressNumber = (value: number) => (
    <img
      width="12"
      height="12"
      src={`/assets/o_series/progress_${value}.svg`}
    />
  )

  let progressFill

  if (step <= 10) {
    progressFill = (33 / 10) * step + '%'
  } else if (step <= 17) {
    const percent = (33 / 7) * (step - 9)
    progressFill = 33 + percent + '%'
  } else {
    const percent = (33 / 3) * (step - 17)
    progressFill = 70 + percent + '%'
  }

  return (
    <div className="px-3 h-6 w-full mb-7 relative flex items-center">
      <div
        style={{ width: progressFill }}
        className={`h-1 transition-all ${s.progress}`}
      ></div>
      <div className="flex-1 transition-all bg-mercury h-1"></div>
      <div
        className={`absolute ltr:left-0 rtl:right-0 top-0 rounded-full h-6 w-6 ${s.completed}`}
      >
        <span className="flex justify-center items-center h-6">
          {progressCheckmark}
        </span>
      </div>
      <div
        className={`absolute ltr:left-1/3 rtl:right-1/3 top-0 rounded-full bg-mercury h-6 w-6 text-center text-white ${
          step >= 10 ? s.completed : ''
        }`}
      >
        <span className="flex justify-center items-center h-6">
          {step >= 10 ? progressCheckmark : progressNumber(1)}
        </span>
      </div>
      <div
        className={`absolute ltr:left-2/3 rtl:right-2/3 top-0 rounded-full bg-mercury h-6 w-6 text-center text-white ${
          step >= 17 ? s.completed : ''
        }`}
      >
        <span className="flex justify-center items-center h-6">
          {step >= 17 ? progressCheckmark : progressNumber(2)}
        </span>
      </div>{' '}
      <div
        className={`absolute ltr:right-0 rtl:left-0 top-0 rounded-full bg-mercury h-6 w-6 text-center text-white ${
          step >= 20 ? s.completed : ''
        }`}
      >
        <span className="flex justify-center items-center h-6">
          {step >= 20 ? progressCheckmark : progressNumber(3)}
        </span>
      </div>
    </div>
  )
}

export default ProgressBar
